import * as React from "react"
import cx from "classnames"

import { ImageResponsive } from "components/Flow/types"
import * as styles from "./styles.module.scss"
import GatsbyLinkWrapper from "components/GatsbyLinkWrapper"
import Tilter from "components/Tilter"

export interface TileLargeProps {
  ctaPrimary?: string
  heading: string
  img: ImageResponsive
  link: string
  subhead?: string
}

const TileLarge: React.FC<TileLargeProps> = ({
  ctaPrimary,
  heading,
  img,
  link,
  subhead,
}) => {
  return (
    <Tilter className={styles.root}>
      <div className={styles.box}>
        <GatsbyLinkWrapper link={link} className={styles.button}>
          <div className={styles.shadow} />
          <figure className={styles.figure}>
            <img
              className={styles.image}
              sizes="28vw"
              src={img.small.src}
              srcSet={`${img.large.src} ${img.large.width}, ${img.small.src} ${img.small.width}`}
              alt={img.alt}
            />
          </figure>
          <div className={styles.content}>
            <h5 className={styles.heading}>{heading}</h5>
            {subhead && (
              <p className={styles.subhead}>
                {subhead}
                <i
                  className={cx({
                    [styles.arrow]: true,
                    ["bsk-icon-arrow-stick-right-thicker"]: true,
                  })}
                />
              </p>
            )}
            {ctaPrimary && (
              <span className={styles.linkPrimary}>{ctaPrimary}</span>
            )}
          </div>
        </GatsbyLinkWrapper>
      </div>
    </Tilter>
  )
}

export default TileLarge
